var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 8.00001C13.9925 8.19499 13.9158 8.42038 13.7879 8.56252L9.09228 13.7444C8.8181 14.0841 8.29066 14.0772 7.9824 13.7712C7.67416 13.4652 7.64888 12.9232 7.95918 12.6194L11.3994 8.81821L2.7826 8.8182C2.35037 8.8182 2 8.45187 2 8.00001C2 7.54812 2.35037 7.18181 2.7826 7.18181L11.3994 7.18181L7.95918 3.38061C7.64893 3.07682 7.67431 2.53254 7.98265 2.2265C8.29092 1.92047 8.82585 1.91914 9.09244 2.25559L13.788 7.4375C13.9309 7.59618 13.9979 7.78126 14 8.00001L13.9998 8.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.8b3fdbed.svg";
export { ForwardRef as ReactComponent };